<template>
  <div>
    <the-hero-section :title="title" :imgLink="imgLink" />
    <vertical-divider />
    <section id="contact" class="extra-padding grey lighten-4">
      <v-container class="extra-padding">
        <v-col cols="12" md="12" class="mx-auto">
          <p
            class="text-justify font-weight-light grey--text text-left text-body-1"
          >
            Si está buscando una empresa que atienda sus requerimientos en
            servicios viales, contáctenos, en Argecam contamos con las
            herramientas necesarias para satisfacer sus necesidades.
          </p>
        </v-col>
        <v-card
          min-height="560"
          width="100%"
          class="rounded-xl"
          style="overflow: hidden !important"
        >
          <v-row justify="center" class="mx-auto">
            <v-col cols="12" sm="7" md="8" class="px-md-10 px-xs-0">
              <v-card-title>
                <h3 class="primary--text font-weight-light">
                  Envianos tu consulta
                </h3>
                <v-spacer></v-spacer>
                <v-icon x-large color="primary">mdi-email-newsletter</v-icon>
              </v-card-title>
              <contact-form />
            </v-col>
            <v-col cols="12" sm="5" md="4" class="primary alto">
              <v-card-title class="no-wrap">
                <h3 class="white--text font-weight-light">
                  Informacón de Contacto
                </h3>
              </v-card-title>
              <contact-info />
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "Contact",
  components: {
    TheHeroSection: () => import("@/components/TheHeroSection"),
    VerticalDivider: () => import("@/components/shape/VerticalDivider.vue"),
    ContactForm: () => import("@/components/ContactForm.vue"),
    ContactInfo: () => import("@/components/ContactInfo.vue")
  },
  data: () => ({
    title: "Contacto",
    imgLink: "section-about.jpeg"
  })
};
</script>

<style scoped>
.alto {
  min-height: 560px;
  height: auto;
}
</style>
